export type Sharded<T> = { -readonly [K in keyof T]?: T[K]; };

const strParamRegex = /\{\s*(\w+)\s*\}/g;
/**
 * Formats the given {@code template} string by substituting the properties of the given {@code params} into the string.
 * Any substrings with format `{@code {name}}` will be substituted by the corresponding parameter value `params[name]`.
 * All the parameter values will be converted to string by {@code toString}.
 *
 * Currently, this function only support the properties at the first level, therefore, deep property expression e.g.
 * `{@code {address.country}}` is not supported.
 *
 * @param template the template string to be formatted
 * @param params an object contains the parameters
 * @return a formatted string
 */
export const formatString = (template: string, params: { [key: string]: any }): string => {
  return template.replace(strParamRegex, (match, param: string) => {
    const val = params[param];
    return val ? val.toString() : '';
  });
};
